import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH SUBSCRIBER ********************
export const fetchSubscriber = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_SUBSCRIBER_LOADING,
			payload: true
		});

		const { data } = await services.get(`/subscriber/${id}`);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_SUBSCRIBER_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_SUBSCRIBER_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
